/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserResetPasswordSubmitPinInput = {
    username: string;
    cellphoneNumber: string;
    pin: string;
    clientMutationId?: string | null;
};
export type ResetUserPasswordSubmitPinMutationVariables = {
    input: UserResetPasswordSubmitPinInput;
};
export type ResetUserPasswordSubmitPinMutationResponse = {
    readonly userResetPasswordSubmitPin: {
        readonly clientMutationId: string | null;
        readonly token: string;
    } | null;
};
export type ResetUserPasswordSubmitPinMutation = {
    readonly response: ResetUserPasswordSubmitPinMutationResponse;
    readonly variables: ResetUserPasswordSubmitPinMutationVariables;
};



/*
mutation ResetUserPasswordSubmitPinMutation(
  $input: UserResetPasswordSubmitPinInput!
) {
  userResetPasswordSubmitPin(input: $input) {
    clientMutationId
    token
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserResetPasswordSubmitPinPayload",
    "kind": "LinkedField",
    "name": "userResetPasswordSubmitPin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetUserPasswordSubmitPinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetUserPasswordSubmitPinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "17144ccc5a2b59de51f19600f06f6e5c",
    "id": null,
    "metadata": {},
    "name": "ResetUserPasswordSubmitPinMutation",
    "operationKind": "mutation",
    "text": "mutation ResetUserPasswordSubmitPinMutation(\n  $input: UserResetPasswordSubmitPinInput!\n) {\n  userResetPasswordSubmitPin(input: $input) {\n    clientMutationId\n    token\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f06a3e585a6faf01174e60418e1cea3b';
export default node;
